export { default as SplineChartV2 } from './SplineChartV2';
export type {
  SplineChartV2Props,
  SplineChartV2Series,
  SplineChartV2DataPoint,
  WeekMeta
} from './SplineChartV2';
export { useWeekIdsForTimePeriod } from './SplineChartV2';

// Utility functions (pure, no React dependencies)
export {
  formatIsoDateToMMDD,
  weekIdToMeta,
  weekIdToTimestamp,
  fillCategoryData,
  createSeriesFromWeekIdMap,
  addMetaToDataPoints,
  mergeComparisonAndPrimaryData,
  alignDataToWeekIds,
  fillMissingWeeksWithNull
} from './splineChartV2Utils';
export type { SplineChartV2DataPointWithMeta } from './splineChartV2Utils';

// V2 data transformation hook
export { useSplineChartV2Data } from './useSplineChartV2Data';
export type { UseSplineChartV2DataArgs, UseSplineChartV2DataResult } from './useSplineChartV2Data';

// V2 data fetching hook
export { useMetricByWeekIdV2, default as useMetricByWeekIdV2Default } from './useMetricByWeekIdV2';
export type { UseMetricByWeekIdV2Args, UseMetricByWeekIdV2Result } from './useMetricByWeekIdV2';

// V2 derived metric hook (for metrics like conversion rate that combine multiple data sources)
export { useDerivedMetricByWeekIdV2, default as useDerivedMetricByWeekIdV2Default } from './useDerivedMetricByWeekIdV2';
export type { UseDerivedMetricByWeekIdV2Args, UseDerivedMetricByWeekIdV2Result } from './useDerivedMetricByWeekIdV2';
